import { render } from "./PaymentMethodTitle.vue?vue&type=template&id=9a30812a"
import script from "./PaymentMethodTitle.vue?vue&type=script&lang=js"
export * from "./PaymentMethodTitle.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__